import React, { useCallback, useContext, useEffect } from 'react'
import SpyLogic from './components/spyLogic'
import {
  useParams,
  UNSAFE_NavigationContext as NavigationContext
} from 'react-router-dom'
import './styles.css'
import { Affix, Col, Modal, Row } from 'antd'
import QuestionsSection from './components/QuestionsSection'
import { useDispatch, useSelector } from 'react-redux'
import {
  getOneSubmission,
  updateSubmission
} from '../../reducers/assessmentTakingReducer'
import Spinner from '../../components/Spinner'
import { autoGrade } from '../../reducers/submissionsReducer'

function useBlocker(blocker, when = true) {
  const navigator = useContext(NavigationContext).navigator

  useEffect(() => {
    if (!when) return

    const unblock = navigator.block((tx) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock()
          tx.retry()
        }
      }

      blocker(autoUnblockingTx)
    })

    return unblock
  }, [navigator, blocker, when])
}

const AssessmentTaking = (props) => {
  const dispatch = useDispatch()
  const { submission, loading } = useSelector((state) => state.assessmentTaking)

  const { assessmentType } = props
  const { courseId, assessmentId } = useParams()
  const user = useSelector((state) => state.auth.user)

  useEffect(() => {
    dispatch(getOneSubmission(courseId, assessmentId, user._id))
  }, [dispatch, courseId, assessmentId, user._id])

  return (
    <>
      {assessmentType === 'Exam' && (
        <ExamTaker submission={submission} loading={loading} />
      )}
      {assessmentType === 'Assignment' && (
        <AssignmentTaker submission={submission} loading={loading} />
      )}
    </>
  )
}

const ExamTaker = (props) => {
  const { submission, loading } = props
  const dispatch = useDispatch()
  const { courseId, assessmentId } = useParams()

  const user = useSelector((state) => state.auth.user)
  
  const handleTimeExpiredSubmission = useCallback(() => {
    dispatch(
      updateSubmission(courseId, assessmentId, user._id, {
        files: submission.files || [],
        finished: true
      })
    ).then(() => {
      dispatch(autoGrade(courseId, assessmentId))
      window.close()
    })
  }, [dispatch, courseId, assessmentId, user._id, submission.files])

  if (loading || Object.keys(submission).length === 0)
    return <Spinner size="large" />

  if (submission.assessment.remainingTime <= 0) {
    Modal.error({
      title: 'The exam has ended',
      onOk() {
        window.close()
      }
    })
    return null
  } else if (submission.finished) {
    Modal.info({
      title: 'Exam already submitted',
      onOk() {
        window.close()
      }
    })
    return null
  } else if (submission.assessment.status.code === 'willOpen') {
    Modal.info({
      title: "Exam didn't open yet",
      onOk() {
        window.close()
      }
    })
    return null
  }

  return (
    <>
      <Row>
        <Col span={20}>
          <QuestionsSection submission={submission} />
        </Col>
        <Col span={4}>
          <Affix offsetTop={10}>
            <SpyLogic
              timeRemaining={submission.assessment.remainingTime}
              examId={submission.assessment.id}
              onTimeExpired={handleTimeExpiredSubmission}
            />
          </Affix>
        </Col>
      </Row>
    </>
  )
}

const AssignmentTaker = (props) => {
  const { submission, loading } = props

  if (loading || Object.keys(submission).length === 0)
    return <Spinner size="large" />

  return (
    <>
      <div style={{ width: '85%', margin: '0 auto' }}>
        <QuestionsSection submission={submission} />
      </div>
    </>
  )
}

export default AssessmentTaking
